import { ApiResult } from "common/models/api-service/api-result.model";
import { ApiBaseError, baseApi } from "common/redux/core/api.base";

const withApiResponse = async <TResponse>(
  asyncMethod: () => Promise<ApiResult<TResponse>>
) => {
  const result = await asyncMethod();

  if (!result?.hasErrors) {
    return {
      data: result?.value as TResponse
    };
  }

  return {
    error: new ApiBaseError(result.statusCode, result.errors, result?.value)
  };
};

export { withApiResponse };
